// extracted by mini-css-extract-plugin
export default {"content":"style_content__gXH5M","checkbox":"style_checkbox__OJOTN"};